package us.laantech.common.dto

enum class UserGroups {
    CONSUMER, // Accounts for public-facing applications.
    EXTERNAL, // Accounts created by business partners
    BUSINESS, // Company client accounts
    INTERNAL // Internal company accounts
}